// extracted by css-extract-rspack-plugin
export default {"root":"ProductMediaOrderInfoBlock_root__nrTOS","text":"ProductMediaOrderInfoBlock_text__BG53H"};